<template>
  <div :class="colBootstrap" class="datapicker-range">
    <input type="text" class="datepicker-style" id="datepickerInitEnd" readonly>
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path class="a" d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z"/>
    </svg>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "datapickerRange",
  props: {
    colBootstrap: '',
  },
  data() {
    return {
      dateValue: '',
      initDate: '',
      endDate: '',
    }
  },
  methods: {

  },
  mounted() {
    const date = new Date();
    this.initDate = moment(date).subtract(30, 'days').format('DD/MM/YYYY')
    this.endDate = moment(date).format('DD/MM/YYYY')
    this.$route.params.dateInit = moment(date).subtract(30, 'days').format('YYYY-MM-DD')
    this.$route.params.dateEnd = moment(date).format('YYYY-MM-DD')

    $('#datepickerInitEnd').daterangepicker({
      "maxSpan": {
        "days": 30
      },
      "startDate": this.initDate,
      "endDate": this.endDate,
      "locale": {
        "format": "DD/MM/YYYY",
        "separator": " - ",
        "applyLabel": "Aplicar",
        "cancelLabel": "Cancelar",
        "fromLabel": "De:",
        "toLabel": "Para:",
        "customRangeLabel": "Personalizados",
        "weekLabel": "Semana",
        "daysOfWeek": [
          "Dom",
          "Seg",
          "Ter",
          "Qua",
          "Qui",
          "Sex",
          "Sáb"
        ],
        "monthNames": [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ],
        "firstDay": 1
      },
    }, (init, end) => {
      this.initDate = moment(init._d).format('YYYY-MM-DD')
      this.endDate = moment(end._d).format('YYYY-MM-DD')

      this.$route.params.dateInit = this.initDate
      this.$route.params.dateEnd = this.endDate
    });
  }
}
</script>

<style lang="scss">

.daterangepicker {
  background: var(--bodyColor) !important;
  color: var(--titleBox) !important;

  &:before {
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    //border-bottom: 7px solid var(--bodyColor) !important;
  }

  &:after {
    background: var(--bodyColor) !important;
    border: var(--bodyColor) !important;
  }

  margin-top: 15px;
  border-radius: 10px !important;
  font-family: Montserrat;
  font-weight: 500;

  .ranges {
    display: none;
  }

  .drp-buttons {
    .drp-selected {
      font-weight: 700;
    }

    .cancelBtn {
      border-radius: 4px !important;
      border: 1px solid #D5DFEB;
      transition: .2s !important;
      background: #D5DFEB;
      color: #3A424E;

      &:hover {
        background: #FFFFFF;
      }
    }

    .applyBtn {
      background: var(--linkColor);
      border: 1px solid var(--linkColor);
      color: #ffffff;
      border-radius: 4px !important;
      transition: .2s !important;
      padding: 4px 28px;

      &:hover {
        background: #261cab;
      }
    }
  }

  .drp-calendar {
    border-radius: 10px !important;

    background: var(--bodyColor) !important;
    color: var(--titleBox) !important;
    border: var(--bodyColor) !important;
  }

  .calendar-table {
    background: var(--bodyColor) !important;
    color: var(--titleBox) !important;
    border: var(--bodyColor) !important;
    .table-condensed {
      thead {
        tr {
          th {
            cursor: auto;
            font-weight: 600;
            min-width: 34px;
            width: 34px;
            max-width: 34px;
          }

          .next {
            cursor: pointer;
            span {
              border-color: var(--titleBox) !important;
            }
          }

          .available {
            &:hover {
              background-color: var(--defaultText) !important;
            }
          }

          .prev {
            cursor: pointer;
            span {
              border-color: var(--titleBox) !important;
            }
          }

          .month {
            background: var(--bodyColor) !important;
            color: var(--titleBox) !important;
            font-weight: 700;
          }
        }
      }

      tbody {
        tr {
          .start-date {
            border-top-left-radius: 8px !important;
            border-bottom-left-radius: 8px !important;
          }

          .end-date {
            border-top-right-radius: 8px !important;
            border-bottom-right-radius: 8px !important;
          }

          .active {
            background-color: #352DA5 !important;
            color: #FFFFFF !important;

            &:hover {
              background-color: #271db0 !important;
            }
          }

          .in-range {
            background-color: #2f23d642;
            color: var(--titleBox);
          }

          .available {
            &:hover {
              background-color: #2f23d61c;
            }
          }

          .off {
            background: var(--bodyColor) !important;
            color: #999 !important;
          }
        }
      }
    }
  }
}

.datapicker-range {
  padding: 0 !important;
  position: relative;

  .datepicker-style {
    width: 100%;
    background: #EEF2F7;
    border-radius: 4px !important;
    padding: 6px 12px 6px 35px;
    transition: .2s;
    cursor: pointer;

    font-size: inherit;
    font-weight: 400;
    color: var(--dark-gray);

    &::placeholder {
      font-size: 16px;
      font-weight: 400;
      color: var(--dark-gray);
    }

    &:hover {
      transition: .2s;
    }

    &:focus-visible {
      outline: none;
      transition: .2s;

      &::placeholder {
        transition: .1s;
        color: #EEF2F7;
      }
    }
  }

  svg {
    pointer-events: none;
    left: 10px;
    top: 7px;
    position: absolute;
    fill: var(--titleBox);
    width: 18px;
    height: 18px;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/components/datapickerRange.vue